    import React, {Component} from 'react'
    import {Layer, Group} from 'react-konva'
    import {KonvaEventObject} from 'konva/lib/Node'
    import ImageElement from './Element/ImageElement'
    import TextElement from './Element/TextElement'
    import BarcodeElement from './Element/BarcodeElement'
    import RfidElement from './Element/RfidElement'
    import Gs1BarcodeElement from './Element/Gs1BarcodeElement'
    import {Element, GroupElement} from '../../views/LabelBuilder/LabelBuilder.slice'
    import LineElement from './Element/LineElement'
    import CircleElement from './Element/CircleElement'
    import RectElement from './Element/RectElement'
    import EllipseElement from './Element/EllipseElement'
    import WedgeElement from './Element/WedgeElement'
    import RingElement from './Element/RingElement'
    import ArcElement from './Element/ArcElement'
    import ArrowElement from './Element/ArrowElement'
    import Konva from 'konva'

    interface Props {
        elements: Element[],
        onElementClick: (event: KonvaEventObject<MouseEvent>) => void,
        onElementTransform: (event: KonvaEventObject<MouseEvent>) => void,
        onElementDrag: (event: KonvaEventObject<DragEvent>) => void,
        onElementRightClick: (event: KonvaEventObject<PointerEvent>) => void,
        onTextUpdate: (id: string, textNode: Konva.Text, newText: string) => void,

        // ✅ NEW
        layerRef: React.RefObject<Konva.Layer>,
        onLayerDragMove: (event: KonvaEventObject<DragEvent>) => void
        // ✅ NEW: stage pixel width so TextElement can compute correct width on reload
        stageWidth?: number,
    }

    export default class Elements extends Component<Props> {
        render() {
            const {stageWidth} = this.props

            return (
                <Layer
                    id="elements"
                    ref={this.props.layerRef}
                    onDragMove={this.props.onLayerDragMove}
                >
                    {this.props.elements.map(element => {
                        if (element.type === 'group') {
                            const group = element as GroupElement
                            return (
                                <Group
                                    key={group.id}
                                    id={group.id}
                                    name="snap-object"
                                    x={group.x}
                                    y={group.y}
                                    scaleX={group.scaleX}
                                    scaleY={group.scaleY}
                                    rotation={group.rotation}
                                    opacity={group.opacity || 1}
                                    draggable={true}
                                    onClick={this.props.onElementClick}
                                    onDragEnd={this.props.onElementDrag}
                                    onTransformEnd={this.props.onElementTransform}
                                    onContextMenu={this.props.onElementRightClick}
                                >
                                    {group.children.map((child: Element) => {
                                        switch (child.type) {
                                            case 'image':
                                                return <ImageElement key={child.id} element={child} draggable={false}  stageWidth={stageWidth}/>
                                            case 'text':
                                                return <TextElement key={child.id} element={child} draggable={false}/>
                                            case 'barcode':
                                                return <BarcodeElement key={child.id} element={child} draggable={false}/>
                                            case 'rfid':
                                                return <RfidElement key={child.id} element={child} draggable={false}/>
                                            case 'line':
                                                return <LineElement key={child.id} element={child} draggable={false}/>
                                            case 'circle':
                                                return <CircleElement key={child.id} element={child} draggable={false}/>
                                            case 'rect':
                                                return <RectElement key={child.id} element={child} draggable={false}/>
                                            case 'ellipse':
                                                return <EllipseElement key={child.id} element={child} draggable={false}/>
                                            case 'wedge':
                                                return <WedgeElement key={child.id} element={child} draggable={false}/>
                                            case 'ring':
                                                return <RingElement key={child.id} element={child} draggable={false}/>
                                            case 'arc':
                                                return <ArcElement key={child.id} element={child} draggable={false}/>
                                            case 'arrow':
                                                return <ArrowElement key={child.id} element={child} draggable={false}/>
                                            default:
                                                return null
                                        }
                                    })}
                                </Group>
                            )
                        }

                        switch (element.type) {
                            case 'image':
                                return <ImageElement key={element.id} element={element}
                                                     name="snap-object"
                                                     onClick={this.props.onElementClick}
                                                     onTransform={this.props.onElementTransform}
                                                     onDrag={this.props.onElementDrag}
                                                     onRightClick={this.props.onElementRightClick}/>
                            case 'text':
                                return <TextElement key={element.id} element={element}
                                                    name="snap-object"
                                                    onClick={this.props.onElementClick}
                                                    onTransform={this.props.onElementTransform}
                                                    onDrag={this.props.onElementDrag}
                                                    onRightClick={this.props.onElementRightClick}
                                                    onTextUpdate={this.props.onTextUpdate}
                                                    stageWidth={stageWidth}/>
                            case 'barcode':
                                return <BarcodeElement key={element.id} element={element}
                                                       name="snap-object"
                                                       onClick={this.props.onElementClick}
                                                       onTransform={this.props.onElementTransform}
                                                       onDrag={this.props.onElementDrag}
                                                       onRightClick={this.props.onElementRightClick}/>
                            case 'rfid':
                                return <RfidElement key={element.id} element={element}
                                                    name="snap-object"
                                                    onClick={this.props.onElementClick}
                                                    onTransform={this.props.onElementTransform}
                                                    onDrag={this.props.onElementDrag}
                                                    onRightClick={this.props.onElementRightClick}/>
                            case 'gs1_barcode':
                                return <Gs1BarcodeElement key={element.id} element={element}
                                                          name="snap-object"
                                                          onClick={this.props.onElementClick}
                                                          onTransform={this.props.onElementTransform}
                                                          onDrag={this.props.onElementDrag}
                                                          onRightClick={this.props.onElementRightClick}/>
                            case 'line':
                                return <LineElement key={element.id} element={element}
                                                    name="snap-object"
                                                    onClick={this.props.onElementClick}
                                                    onTransform={this.props.onElementTransform}
                                                    onDrag={this.props.onElementDrag}
                                                    onRightClick={this.props.onElementRightClick}/>
                            case 'circle':
                                return <CircleElement key={element.id} element={element}
                                                      name="snap-object"
                                                      onClick={this.props.onElementClick}
                                                      onTransform={this.props.onElementTransform}
                                                      onDrag={this.props.onElementDrag}
                                                      onRightClick={this.props.onElementRightClick}/>
                            case 'rect':
                                return <RectElement key={element.id} element={element}
                                                    name="snap-object"
                                                    onClick={this.props.onElementClick}
                                                    onTransform={this.props.onElementTransform}
                                                    onDrag={this.props.onElementDrag}
                                                    onRightClick={this.props.onElementRightClick}/>
                            case 'ellipse':
                                return <EllipseElement key={element.id} element={element}
                                                       name="snap-object"
                                                       onClick={this.props.onElementClick}
                                                       onTransform={this.props.onElementTransform}
                                                       onDrag={this.props.onElementDrag}
                                                       onRightClick={this.props.onElementRightClick}/>
                            case 'wedge':
                                return <WedgeElement key={element.id} element={element}
                                                     name="snap-object"
                                                     onClick={this.props.onElementClick}
                                                     onTransform={this.props.onElementTransform}
                                                     onDrag={this.props.onElementDrag}
                                                     onRightClick={this.props.onElementRightClick}/>
                            case 'ring':
                                return <RingElement key={element.id} element={element}
                                                    name="snap-object"
                                                    onClick={this.props.onElementClick}
                                                    onTransform={this.props.onElementTransform}
                                                    onDrag={this.props.onElementDrag}
                                                    onRightClick={this.props.onElementRightClick}/>
                            case 'arc':
                                return <ArcElement key={element.id} element={element}
                                                   name="snap-object"
                                                   onClick={this.props.onElementClick}
                                                   onTransform={this.props.onElementTransform}
                                                   onDrag={this.props.onElementDrag}
                                                   onRightClick={this.props.onElementRightClick}/>
                            case 'arrow':
                                return <ArrowElement key={element.id} element={element}
                                                     name="snap-object"
                                                     onClick={this.props.onElementClick}
                                                     onTransform={this.props.onElementTransform}
                                                     onDrag={this.props.onElementDrag}
                                                     onRightClick={this.props.onElementRightClick}/>
                            default:
                                return null
                        }
                    })}
                </Layer>
            )
        }
    }
